import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserStorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserCountrySelectedService {
  private storageKey = 'UserCountrySelected';

  private userCountrySelectedSubject = new BehaviorSubject<string | undefined>(
    undefined
  );
  public userCountrySelectedSubject$ =
    this.userCountrySelectedSubject.asObservable();

  constructor(private browserStorageService: BrowserStorageService) {
    this.userCountrySelectedSubject.next(this.getUserCountrySelected());
  }

  getUserCountrySelected(): string | undefined {
    const storedCountrySelected = this.browserStorageService.get(
      this.storageKey
    );
    return storedCountrySelected ? storedCountrySelected : undefined;
  }

  updateUserCountrySelected(countryId: string): void {
    this.browserStorageService.set(this.storageKey, countryId.toString());
    this.userCountrySelectedSubject.next(countryId);
  }
}
